var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h-stack',{staticClass:"paginationVue"},[_c('el-pagination',{attrs:{"page-size":_vm.pageSize,"pager-count":5,"current-page":_vm.page,"layout":"prev, pager, next","total":_vm.totalCount},on:{"current-change":_vm.currentChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }